import styled from 'styled-components'

import { Modal } from 'antd'

export const Card = styled(Modal)`
  width: 800px !important;
  height: 405px !important;

  .ant-modal-body {
    display: flex;
    justify-content: center !important;
    align-items: center !important;
  }

  .ant-modal-title {
    font-size: 23px;
  }
`
